/* Vasenzeit Aura-Konfigurator — ausgelagert aus dem Custom-Liquid-Block
   (50-KB-Limit pro liquid-Setting). Konfiguration kommt aus den
   data-Attributen auf [data-lv-aura-root] und den JSON-Script-Tags.
   Änderungen hier vornehmen, nicht im Liquid. */
(function () {
  'use strict';

  function lvAuraInit(LV_ROOT, LV_UID) {
    'use strict';
    var WRAP_ID = 'lv-aura-wrap-' + LV_UID;

    var FALLBACK_PALETTE = [
      { hex: '#b5674a', light: false, name: '', image: '' },
      { hex: '#3d5241', light: false, name: '', image: '' },
      { hex: '#4a3428', light: false, name: '', image: '' },
      { hex: '#2e2620', light: false, name: '', image: '' },
      { hex: '#faf8f4', light: true, name: '', image: '' },
      { hex: '#c8887a', light: false, name: '', image: '' },
      { hex: '#b89060', light: false, name: '', image: '' },
      { hex: '#9a8f84', light: false, name: '', image: '' },
      { hex: '#e8dfd0', light: true, name: '', image: '' },
      { hex: '#5c7060', light: false, name: '', image: '' },
      { hex: '#8f4a30', light: false, name: '', image: '' },
      { hex: '#6b5d52', light: false, name: '', image: '' }
    ];

    var VARIANT_DATA = { options: [] };
    (function loadVariantData() {
      var el = document.getElementById('lv-aura-variant-data-' + LV_UID);
      if (!el) return;
      try {
        VARIANT_DATA = JSON.parse((el.textContent || '').trim() || '{}');
      } catch (e) {
        VARIANT_DATA = { options: [] };
      }
    })();

    function clonePal(p) {
      return (p || []).map(function (x) {
        return { hex: x.hex, light: !!x.light, name: x.name || '', image: x.image || '' };
      });
    }

    var VASE_TITLES = ['Vase links', 'Vase mitte', 'Vase rechts'];
    var VASE_PALETTES_PER = [clonePal(FALLBACK_PALETTE), clonePal(FALLBACK_PALETTE), clonePal(FALLBACK_PALETTE)];
    var rawOpts = VARIANT_DATA.options || [];
    if (rawOpts.length) {
      var pad = rawOpts.slice();
      while (pad.length < 3) pad.push(pad[pad.length - 1]);
      pad = pad.slice(0, 3);
      for (var pi = 0; pi < 3; pi++) {
        if (pad[pi].values && pad[pi].values.length) VASE_PALETTES_PER[pi] = clonePal(pad[pi].values);
        if (pad[pi].name) VASE_TITLES[pi] = String(pad[pi].name).trim();
      }
      var defLab = ['Vase links', 'Vase mitte', 'Vase rechts'];
      var n0 = (VASE_TITLES[0] || '').toLowerCase();
      if (
        n0 &&
        (VASE_TITLES[1] || '').toLowerCase() === n0 &&
        (VASE_TITLES[2] || '').toLowerCase() === n0
      ) {
        VASE_TITLES[0] = defLab[0];
        VASE_TITLES[1] = defLab[1];
        VASE_TITLES[2] = defLab[2];
      }
    }
    function mergeSharedPalette(pals) {
      var seen = Object.create(null);
      var out = [];
      for (var ri = 0; ri < pals.length; ri++) {
        var P = pals[ri] || [];
        for (var k = 0; k < P.length; k++) {
          var item = P[k];
          var disp = (item.name && String(item.name).trim()) ? item.name.trim() : (item.hex || '');
          var key = disp.toLowerCase();
          if (!key || seen[key]) continue;
          seen[key] = true;
          out.push({ hex: item.hex || '', light: !!item.light, name: item.name || '', image: item.image || '' });
        }
      }
      return out.length ? out : clonePal(FALLBACK_PALETTE);
    }
    var SHARED_PALETTE = mergeSharedPalette(VASE_PALETTES_PER);

    var wrap = document.getElementById(WRAP_ID);
    if (!wrap) return;

    var perVase = wrap.getAttribute('data-lv-per-vase') === 'true';

    var mode = (wrap.getAttribute('data-lv-aura-mode') || 'mask').toLowerCase();
    var isTiles = mode === 'tiles';

    var vaseCount = parseInt(wrap.getAttribute('data-lv-vases') || '3', 10);
    if (vaseCount < 2) vaseCount = 2;
    if (vaseCount > 3) vaseCount = 3;
    wrap.setAttribute('data-lv-vases', String(vaseCount));

    var TILE_PH = LV_ROOT.getAttribute('data-lv-aura-basis') || '';

    var productData = null;
    var boot = {
      initialOptions: [],
      moneyFormat: LV_ROOT.getAttribute('data-lv-money-format') || '',
      currency: LV_ROOT.getAttribute('data-lv-currency') || ''
    };
    (function loadProduct() {
      var pel = document.getElementById('lv-aura-product-' + LV_UID);
      var bel = document.getElementById('lv-aura-boot-' + LV_UID);
      if (pel) {
        try {
          productData = JSON.parse(pel.textContent || '{}');
        } catch (e) {
          productData = null;
        }
      }
      if (bel) {
        try {
          var b = JSON.parse(bel.textContent || '{}');
          if (Array.isArray(b.initialOptions)) boot.initialOptions = b.initialOptions;
          if (b.moneyFormat) boot.moneyFormat = b.moneyFormat;
          if (b.currency) boot.currency = b.currency;
        } catch (e2) {}
      }
    })();

    var uidS = LV_UID;
    var selVariant = document.getElementById('lvAuraVariant-' + uidS);
    var priceEl = document.getElementById('lvAuraPrice-' + uidS);
    var priceRow = document.getElementById('lvAuraPriceRow-' + uidS);
    var stockEl = document.getElementById('lvAuraStock-' + uidS);
    var addBtn = document.getElementById('lvAuraAdd-' + uidS);
    var qtyEl = document.getElementById('lvAuraQty-' + uidS);
    var formEl = document.getElementById(LV_ROOT.getAttribute('data-lv-aura-form') || '') || wrap.querySelector('form.lv-aura__form');
    var cartColorInput = document.getElementById('lvAuraCartColors-' + uidS);

    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, boot.moneyFormat);
      }
      return (cents / 100).toFixed(2) + ' ' + (boot.currency || '');
    }

    function optionSlots() {
      if (productData && productData.options && productData.options.length) return productData.options.length;
      var v0 = productData && productData.variants && productData.variants[0];
      if (!v0) return 3;
      var n = 0;
      if (v0.option1 !== undefined && v0.option1 !== null && v0.option1 !== '') n = 1;
      if (v0.option2 !== undefined && v0.option2 !== null && v0.option2 !== '') n = 2;
      if (v0.option3 !== undefined && v0.option3 !== null && v0.option3 !== '') n = 3;
      return n || 3;
    }

    function variantOpts(v) {
      if (!v) return [];
      var n = optionSlots();
      var arr = [];
      if (Array.isArray(v.options) && v.options.length) {
        for (var i = 0; i < n; i++) {
          var x = i < v.options.length ? v.options[i] : null;
          arr.push(x != null && x !== '' ? String(x) : null);
        }
        return arr;
      }
      if (n >= 1) arr.push(v.option1 != null && v.option1 !== '' ? String(v.option1) : null);
      if (n >= 2) arr.push(v.option2 != null && v.option2 !== '' ? String(v.option2) : null);
      if (n >= 3) arr.push(v.option3 != null && v.option3 !== '' ? String(v.option3) : null);
      return arr.slice(0, n);
    }

    function optionNameAt(idx) {
      if (!productData || !productData.options) return '';
      var o = productData.options[idx];
      if (typeof o === 'string') return o;
      if (o && typeof o === 'object' && o.name) return String(o.name);
      return '';
    }

    // Farbnamen genau so übernehmen, wie sie in Shopify heissen (z. B. „Forest Sage“),
    // nur überflüssige Leerzeichen entfernen.
    function prettyColorPhrase(val) {
      return String(val || '').trim().replace(/\s+/g, ' ');
    }

    function cartVaseSlotLabel(vi) {
      if (vaseCount === 2) {
        return vi === 0 ? 'Vase links' : 'Vase rechts';
      }
      if (vi === 0) return 'Vase links';
      if (vi === 1) return 'Vase mitte';
      if (vi === 2) return 'Vase rechts';
      return 'Vase';
    }

    function buildFarbkombinationText() {
      var slots = optionSlots();
      var parts = [];
      if (perVase) {
        visibleVaseIndices().forEach(function (vi) {
          var val = String(vaseValues[vi] || '').trim();
          if (!val) return;
          var label = cartVaseSlotLabel(vi);
          parts.push(label + ': ' + prettyColorPhrase(val));
        });
      } else {
        var sel = getAuraMergedSelection();
        for (var i = 0; i < slots; i++) {
          var v = sel[i];
          if (v == null || v === '') continue;
          var nm = optionNameAt(i);
          parts.push(nm ? nm + ': ' + prettyColorPhrase(v) : prettyColorPhrase(String(v)));
        }
      }
      // Kasse zeigt keine Zeilenumbrüche — darum mit „ · “ trennen (Warenkorb.txt macht daraus wieder Zeilen).
      var joiner = ' · ';
      var s = parts.join(joiner);
      if (s.length > 250) s = s.slice(0, 247) + '…';
      return s;
    }

    function syncCartColorProperty() {
      if (cartColorInput) cartColorInput.value = buildFarbkombinationText();
      syncCartPreviewProps();
    }

    // Die im Konfigurator sichtbaren Kachelbilder als versteckte Properties mitgeben,
    // damit der Warenkorb genau diese Vorschau zeigt statt eines Beispielfotos.
    function syncCartPreviewProps() {
      if (!perVase) return;
      var vasesEl = document.getElementById('lvAuraPrevVases-' + uidS);
      var layoutEl = document.getElementById('lvAuraPrevLayout-' + uidS);
      if (vasesEl) vasesEl.value = String(vaseCount);
      if (layoutEl) layoutEl.value = wrap.getAttribute('data-lv-aura-layout') || '';
      for (var vi = 0; vi < 3; vi++) {
        var input = document.getElementById('lvAuraPrev' + vi + '-' + uidS);
        if (!input) continue;
        if (vaseCount === 2 && vi === 1) {
          input.value = '';
          continue;
        }
        var im = wrap.querySelector('[data-lv-tile-img="' + vi + '"]');
        var src = im ? (im.getAttribute('src') || '') : '';
        if (!src) {
          var ent = paletteEntryFor(vi, vaseValues[vi]);
          src = ent && ent.image ? ent.image : TILE_PH || '';
        }
        input.value = src;
      }
    }

    var vaseValues = ['', '', ''];

    function getAuraMergedSelection() {
      var slots = optionSlots();
      var sel = new Array(slots).fill(null);
      var ro = VARIANT_DATA.options || [];
      if (perVase) {
        for (var vi = 0; vi < 3; vi++) {
          if (vaseCount === 2 && vi === 1) continue;
          if (!ro[vi] || !vaseValues[vi]) continue;
          var pos = typeof ro[vi].position === 'number' ? ro[vi].position : vi;
          if (pos >= 0 && pos < slots) sel[pos] = vaseValues[vi];
        }
      }
      if (formEl) {
        formEl.querySelectorAll('[data-aura-option-index]').forEach(function (row) {
          var idx = parseInt(row.getAttribute('data-aura-option-index'), 10);
          var ci = row.querySelector('input[data-aura-option-value]:checked');
          if (!isNaN(idx) && ci && idx < slots) sel[idx] = ci.value;
        });
      }
      return sel;
    }

    function optStrEq(a, b) {
      var ae = a == null || a === '';
      var be = b == null || b === '';
      if (ae && be) return true;
      if (ae || be) return false;
      return String(a).trim().toLowerCase() === String(b).trim().toLowerCase();
    }

    function variantAvailable(v) {
      if (!v) return false;
      if (typeof v.available === 'boolean') return v.available;
      if (typeof v.available_for_sale === 'boolean') return v.available_for_sale;
      if (typeof v.availableForSale === 'boolean') return v.availableForSale;
      return true;
    }

    function findVariantFromSelection(sel) {
      if (!productData || !productData.variants || !productData.variants.length) return null;
      var slots = optionSlots();
      var s = sel.slice(0, slots);
      while (s.length < slots) s.push(null);
      return productData.variants.find(function (v) {
        var vo = variantOpts(v);
        for (var i = 0; i < slots; i++) {
          var a = s[i];
          var b = vo[i];
          if (a != null && a !== '' && !optStrEq(a, b == null ? '' : b)) return false;
        }
        return true;
      });
    }

    function syncVariantPdp(variant) {
      if (!variant || !selVariant) return;
      selVariant.value = String(variant.id);
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      var compareEl = document.getElementById('lvAuraCompare-' + uidS);
      var badge = priceRow && priceRow.querySelector('.lv-pdp-price-badge');
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (!compareEl) {
          compareEl = document.createElement('span');
          compareEl.className = 'lv-pdp-price-was';
          compareEl.id = 'lvAuraCompare-' + uidS;
          priceRow.appendChild(compareEl);
        }
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'lv-pdp-price-badge';
          badge.textContent = 'Angebot';
          priceRow.appendChild(badge);
        }
      } else {
        if (compareEl) compareEl.remove();
        if (badge) badge.remove();
      }
      if (stockEl) {
        stockEl.textContent = variantAvailable(variant) ? 'Auf Lager — Versand in 3–5 Werktagen' : 'Derzeit ausverkauft';
        stockEl.classList.toggle('is-out', !variantAvailable(variant));
      }
      if (addBtn) {
        addBtn.disabled = !variantAvailable(variant);
        addBtn.textContent = variantAvailable(variant) ? 'In den Warenkorb' : 'Ausverkauft';
      }
    }

    function applyAuraPdp() {
      if (!productData) return;
      var v = findVariantFromSelection(getAuraMergedSelection());
      if (!v && selVariant && selVariant.value) {
        v = productData.variants.find(function (x) { return String(x.id) === String(selVariant.value); });
      }
      if (v) syncVariantPdp(v);
      syncCartColorProperty();
    }

    function initVaseValues() {
      for (var vi = 0; vi < 3; vi++) {
        if (vaseCount === 2 && vi === 1) continue;
        var pal = VASE_PALETTES_PER[vi] || FALLBACK_PALETTE;
        var want = '';
        if (boot.initialOptions && boot.initialOptions.length && rawOpts[vi]) {
          var posP = typeof rawOpts[vi].position === 'number' ? rawOpts[vi].position : vi;
          if (posP >= 0 && posP < boot.initialOptions.length && boot.initialOptions[posP] != null && boot.initialOptions[posP] !== '') {
            want = String(boot.initialOptions[posP]);
          }
        }
        if (want) {
          vaseValues[vi] = want;
        } else {
          var first = pal[0];
          vaseValues[vi] = (first && first.name && String(first.name).trim()) ? first.name.trim() : (first && first.hex) ? String(first.hex) : '';
        }
      }
    }

    function paletteEntryFor(vi, disp) {
      var key = String(disp || '').toLowerCase();
      var pal = VASE_PALETTES_PER[vi] || [];
      for (var i = 0; i < pal.length; i++) {
        var item = pal[i];
        var d = (item.name && String(item.name).trim()) ? item.name.trim() : (item.hex || '');
        if (String(d).toLowerCase() === key) return item;
      }
      for (var j = 0; j < SHARED_PALETTE.length; j++) {
        var it2 = SHARED_PALETTE[j];
        var d2 = (it2.name && String(it2.name).trim()) ? it2.name.trim() : (it2.hex || '');
        if (String(d2).toLowerCase() === key) return it2;
      }
      return null;
    }

    var activeVaseIdx = 0;

    function visibleVaseIndices() {
      var a = [];
      for (var v = 0; v < 3; v++) {
        if (vaseCount === 2 && v === 1) continue;
        a.push(v);
      }
      return a;
    }

    function syncVaseSlotActiveClasses() {
      var row = wrap.querySelector('[data-lv-vase-slot-row]');
      if (!row) return;
      row.querySelectorAll('[data-lv-vase-slot]').forEach(function (el) {
        var si = parseInt(el.getAttribute('data-lv-vase-slot'), 10);
        el.setAttribute('aria-pressed', si === activeVaseIdx ? 'true' : 'false');
        el.classList.toggle('is-active', si === activeVaseIdx);
      });
    }

    function formatVaseSlotCaption(raw) {
      var t = String(raw || '').trim();
      if (!t) return '';
      var lower = t.toLowerCase();
      if (lower === 'vase links') return 'Vase links';
      if (lower === 'vase mitte') return 'Vase mitte';
      if (lower === 'vase rechts' || lower === 'vase recht') return 'Vase rechts';
      return t
        .split(/\s+/)
        .filter(Boolean)
        .map(function (w) {
          return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
        })
        .join(' ');
    }

    function buildVaseSlots() {
      var row = wrap.querySelector('[data-lv-vase-slot-row]');
      if (!row) return;
      row.innerHTML = '';
      visibleVaseIndices().forEach(function (vi) {
        var bt = document.createElement('button');
        bt.type = 'button';
        bt.className = 'lv-aura__vase-slot';
        bt.setAttribute('data-lv-vase-slot', String(vi));
        bt.setAttribute('aria-pressed', vi === activeVaseIdx ? 'true' : 'false');
        if (vi === activeVaseIdx) bt.classList.add('is-active');
        var shape = document.createElement('span');
        shape.className = 'lv-aura__vase-slot-shape';
        var fill = document.createElement('span');
        fill.className = 'lv-aura__vase-slot-fill';
        fill.setAttribute('data-lv-slot-fill', String(vi));
        var lbl = document.createElement('span');
        lbl.className = 'lv-aura__vase-slot-lbl';
        lbl.textContent = formatVaseSlotCaption(VASE_TITLES[vi] || 'Vase');
        shape.appendChild(fill);
        bt.appendChild(shape);
        bt.appendChild(lbl);
        bt.addEventListener('click', function () {
          activeVaseIdx = vi;
          syncVaseSlotActiveClasses();
          syncRadioCheckFromActive();
          updateActiveVaseLabel();
          updatePaletteColorNameLabel();
        });
        row.appendChild(bt);
      });
    }

    function updateSlotFill(vi) {
      var fill = wrap.querySelector('[data-lv-slot-fill="' + vi + '"]');
      if (!fill) return;
      var entry = paletteEntryFor(vi, vaseValues[vi]);
      var hx = entry && entry.hex ? entry.hex : '#ccc';
      fill.style.backgroundColor = hx;
    }

    function updateAllSlotFills() {
      visibleVaseIndices().forEach(function (vi) {
        updateSlotFill(vi);
      });
    }

    function updateActiveVaseLabel() {
      var lab = wrap.querySelector('[data-lv-active-vase-label]');
      if (lab) lab.textContent = formatVaseSlotCaption(VASE_TITLES[activeVaseIdx] || '');
    }

    function updatePaletteColorNameLabel() {
      var lab = wrap.querySelector('[data-lv-palette-color-name]');
      if (!lab) return;
      lab.textContent = vaseValues[activeVaseIdx] || '';
    }

    function syncRadioCheckFromActive() {
      var host = wrap.querySelector('[data-lv-swatches-shared]');
      if (!host) return;
      var want = String(vaseValues[activeVaseIdx] || '').toLowerCase();
      host.querySelectorAll('input[type="radio"]').forEach(function (inp) {
        var w = (inp.getAttribute('data-lv-name') || inp.value || '').toLowerCase();
        inp.checked = w === want;
      });
    }

    function onSharedPick(ev) {
      var inp = ev.target;
      if (!inp || inp.type !== 'radio' || !inp.checked) return;
      var name = inp.getAttribute('data-lv-name') || inp.value;
      vaseValues[activeVaseIdx] = name;
      updateSlotFill(activeVaseIdx);
      updatePaletteColorNameLabel();

      // Bild und Farbe aus der Palette der aktiven Vase holen. Die gemeinsame
      // Palette führt gleiche Farbnamen zusammen und trägt darum immer das Bild
      // der ersten Vase — für Mitte und Rechts wäre das der falsche Ausschnitt.
      var ent = paletteEntryFor(activeVaseIdx, name);
      var imgUrl = ent && ent.image ? String(ent.image).trim() : (inp.getAttribute('data-lv-img') || '').trim();
      var hex = ent && ent.hex ? ent.hex : inp.getAttribute('data-lv-hex');

      if (isTiles) {
        var img = wrap.querySelector('[data-lv-tile-img="' + activeVaseIdx + '"]');
        var src = imgUrl || TILE_PH || '';
        if (img && src) img.setAttribute('src', src);
      } else {
        var layer = wrap.querySelector('[data-lv-tint-layer="' + activeVaseIdx + '"]');
        if (layer) layer.style.setProperty('--lv-tint', hex);
      }
      applyAuraPdp();
    }

    function buildSharedSwatches() {
      var host = wrap.querySelector('[data-lv-swatches-shared]');
      if (!host) return;
      host.innerHTML = '';
      var groupName = WRAP_ID + '-tone-shared';
      SHARED_PALETTE.forEach(function (item, idx) {
        var disp = (item.name && String(item.name).trim()) ? item.name.trim() : (item.hex || '');
        var labEl = document.createElement('label');
        labEl.className = 'lv-pdp-swatch';
        labEl.setAttribute('title', disp);
        var inp = document.createElement('input');
        inp.type = 'radio';
        inp.name = groupName;
        inp.value = disp;
        inp.setAttribute('data-lv-hex', item.hex || '');
        inp.setAttribute('data-lv-name', disp);
        inp.setAttribute('data-lv-img', item.image || '');
        inp.setAttribute('data-lv-color-idx', String(idx));
        inp.addEventListener('change', onSharedPick);
        var fill = document.createElement('span');
        fill.className = 'lv-pdp-swatch-fill' + (item.light ? ' is-light' : '');
        fill.style.backgroundColor = item.hex || '';
        var sr = document.createElement('span');
        sr.className = 'lv-pdp-swatch-name';
        sr.textContent = disp;
        labEl.appendChild(inp);
        labEl.appendChild(fill);
        labEl.appendChild(sr);
        host.appendChild(labEl);
      });
    }

    function syncSimplePreview() {
      if (perVase) return;
      var row = formEl && formEl.querySelector('[data-aura-option-index].is-color');
      var inp = row && row.querySelector('input[data-aura-option-value]:checked');
      if (!inp && formEl) {
        row = formEl.querySelector('[data-aura-option-index]');
        inp = row && row.querySelector('input[data-aura-option-value]:checked');
      }
      if (!inp) return;
      var name = inp.value;
      var entry = paletteEntryFor(0, name);
      var hex = entry && entry.hex ? entry.hex : '';
      var imgUrl = entry && entry.image ? String(entry.image).trim() : '';
      if (isTiles) {
        var wim = wrap.querySelector('[data-lv-tile-img-whole]');
        if (!wim) return;
        var v = findVariantFromSelection(getAuraMergedSelection());
        var vsrc = '';
        if (v && v.featured_image) {
          var fi = v.featured_image;
          vsrc = typeof fi === 'string' ? fi : (fi.src || '');
        }
        if (!vsrc && imgUrl) vsrc = imgUrl;
        if (!vsrc && TILE_PH) vsrc = TILE_PH;
        if (vsrc) wim.setAttribute('src', vsrc);
      } else {
        var full = wrap.querySelector('[data-lv-tint-full]');
        if (full && hex) full.style.setProperty('--lv-tint', hex);
      }
    }

    if (perVase) {
    initVaseValues();
    buildVaseSlots();
    buildSharedSwatches();
    syncRadioCheckFromActive();
    syncVaseSlotActiveClasses();
    updateActiveVaseLabel();
    updatePaletteColorNameLabel();
    updateAllSlotFills();

    if (isTiles) {
      for (var t = 0; t < 3; t++) {
        if (vaseCount === 2 && t === 1) continue;
        var im = wrap.querySelector('[data-lv-tile-img="' + t + '"]');
        if (!im) continue;
        var ent = paletteEntryFor(t, vaseValues[t]);
        var src = ent && (ent.image || '').trim() ? ent.image.trim() : TILE_PH || '';
        if (src) im.setAttribute('src', src);
      }
    } else {
      for (var j = 0; j < 3; j++) {
        if (vaseCount === 2 && j === 1) continue;
        var lay = wrap.querySelector('[data-lv-tint-layer="' + j + '"]');
        var entJ = paletteEntryFor(j, vaseValues[j]);
        if (lay && entJ) lay.style.setProperty('--lv-tint', entJ.hex || '');
      }
    }

    } else {
      syncSimplePreview();
    }

    applyAuraPdp();

    // Galeriebilder: Bei der Vasen-Konfiguration (Kacheln) als eigene Ebene über der Vorschau zeigen,
    // statt sie in die Kacheln zu schreiben. Sonst zeigt jede Kachel einen Ausschnitt des Galeriebilds,
    // und die Warenkorb-Vorschau (_lv_prev_*) würde diese Ausschnitte übernehmen.
    var galleryStage = wrap.querySelector('.lv-aura__stage');
    var galleryView = null;

    function ensureGalleryView() {
      if (galleryView || !galleryStage) return galleryView;
      var inner = galleryStage.querySelector('.lv-aura__stage-inner') || galleryStage;
      galleryView = document.createElement('div');
      galleryView.className = 'lv-aura__gallery-view';
      var gImg = document.createElement('img');
      gImg.alt = '';
      gImg.decoding = 'async';
      var back = document.createElement('button');
      back.type = 'button';
      back.className = 'lv-aura__gallery-back';
      back.textContent = '\u2190 Zurück zu deiner Auswahl';
      back.addEventListener('click', function () { showAuraConfig(); });
      galleryView.appendChild(gImg);
      galleryView.appendChild(back);
      inner.appendChild(galleryView);
      return galleryView;
    }

    function showAuraConfig() {
      if (galleryStage) galleryStage.classList.remove('is-gallery');
      var row = wrap.querySelector('[data-lv-aura-gallery-row]');
      if (row) {
        row.querySelectorAll('.lv-aura__gallery-thumb').forEach(function (b) {
          b.classList.remove('is-active');
        });
      }
    }

    if (perVase && isTiles) {
      // Jede Interaktion mit dem Konfigurator (Vase oder Farbe wählen) zeigt wieder die Zusammenstellung.
      var slotRow = wrap.querySelector('[data-lv-vase-slot-row]');
      if (slotRow) slotRow.addEventListener('click', showAuraConfig);
      var sharedHost = wrap.querySelector('[data-lv-swatches-shared]');
      if (sharedHost) sharedHost.addEventListener('change', showAuraConfig);
    }

    (function bindAuraGalleryThumbs() {
      var galleryRow = wrap.querySelector('[data-lv-aura-gallery-row]');
      if (!galleryRow) return;
      galleryRow.addEventListener('click', function (ev) {
        var btn = ev.target.closest('.lv-aura__gallery-thumb');
        if (!btn || !galleryRow.contains(btn)) return;
        ev.preventDefault();
        var url = (btn.getAttribute('data-lv-aura-gallery-full') || '').trim();
        if (!url) return;
        galleryRow.querySelectorAll('.lv-aura__gallery-thumb').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        var base = wrap.querySelector('.lv-aura__base');
        if (base) {
          base.setAttribute('src', url);
          return;
        }
        var whole = wrap.querySelector('[data-lv-tile-img-whole]');
        if (whole) {
          whole.setAttribute('src', url);
          return;
        }
        var view = ensureGalleryView();
        if (!view) return;
        var gi = view.querySelector('img');
        gi.setAttribute('src', url);
        gi.setAttribute('alt', btn.getAttribute('aria-label') || '');
        galleryStage.classList.add('is-gallery');
      });
    })();

    if (formEl && qtyEl) {
      var qm = formEl.querySelector('[data-aura-qty-minus]');
      var qp = formEl.querySelector('[data-aura-qty-plus]');
      if (qm) qm.addEventListener('click', function () { qtyEl.value = Math.max(1, parseInt(qtyEl.value || 1, 10) - 1); });
      if (qp) qp.addEventListener('click', function () { qtyEl.value = Math.max(1, parseInt(qtyEl.value || 1, 10) + 1); });
    }
    if (formEl) {
      formEl.addEventListener('submit', function () {
        syncCartColorProperty();
      });
      formEl.querySelectorAll('input[data-aura-option-value]').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var row = inp.closest('[data-aura-option-index]');
          var ix = row && row.getAttribute('data-aura-option-index');
          var lbl = ix != null ? formEl.querySelector('[data-aura-opt-label="' + ix + '"]') : null;
          if (lbl) lbl.textContent = inp.value;
          applyAuraPdp();
          if (!perVase) syncSimplePreview();
        });
      });
      if (selVariant) {
        selVariant.addEventListener('change', function () {
          if (!productData) return;
          var v = productData.variants.find(function (x) { return String(x.id) === String(selVariant.value); });
          if (v) syncVariantPdp(v);
          syncCartColorProperty();
          if (!perVase) syncSimplePreview();
        });
      }
    }
  }

  function lvAuraInitAll() {
    var roots = document.querySelectorAll('[data-lv-aura-root]');
    for (var i = 0; i < roots.length; i++) {
      var el = roots[i];
      if (el.getAttribute('data-lv-aura-ready') === '1') continue;
      el.setAttribute('data-lv-aura-ready', '1');
      lvAuraInit(el, el.getAttribute('data-lv-aura-uid') || '');
    }
  }

  lvAuraInitAll();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lvAuraInitAll);
  }
})();
